<script setup lang="ts">
import { borderGameList } from './data'
import StopToEnd from './components/StopToEnd.vue'
import CrazyGraffiti from './components/CrazyGraffiti.vue'
import { ref } from 'vue'
import { QuestionFilled } from '@element-plus/icons-vue'
import FishingCompetition from './components/FishingCompetition.vue'

const curBoderGame = ref('')
</script>

<template>
  <div class="pub-page page">
    <div v-show="!curBoderGame">
      <h2>酒馆</h2>
      <div class="border-game border-wrap">
        <h4>
          桌游
          <div class="help-info">
            <el-popover placement="bottom" width="100%" trigger="click">
              <template #reference>
                <el-icon size="20">
                  <QuestionFilled />
                </el-icon>
              </template>
              <div class="affix">
                <h4>桌游说明</h4>
                <p>
                  1. 在酒馆桌游中，系统<span class="hp">不提供金币</span>，您可自愿花费<span class="info">参与费</span>加入桌游，获胜时，您将<span
                    class="grow"
                    >获取其他玩家的金币</span
                  >，反之您将<span class="hp">失去参与费</span>。
                </p>
                <p>2. 桌游秉持轻量化原则，均不强制在线参与。</p>
              </div>
            </el-popover>
          </div>
        </h4>
        <div class="border-game-list">
          <el-button type="primary" plain class="item" v-for="item of borderGameList" @click="curBoderGame = item.name">
            <el-icon>
              <component :is="item.icon" />
            </el-icon>
            <div>
              <h5>{{ item.title }}</h5>
              <p>{{ item.desc }}</p>
            </div>
          </el-button>
        </div>
      </div>
      <!-- <div class="border-game border-wrap" style="margin-top: 20px;">
        <h4>对战</h4>
        <div class="border-game-list">
          <el-button type="primary" plain class="item" @click="commonStore.path = 'PvpCard'">
            <el-icon>
              <SwitchFilled />
            </el-icon>
            <div>
              <h5>战魂对决</h5>
              <p>构建您的卡组，与其他玩家展开对决吧</p>
            </div>
          </el-button>
        </div>
      </div> -->
    </div>

    <StopToEnd v-if="curBoderGame === 'StopToEnd'" @back="curBoderGame = ''" />
    <CrazyGraffiti v-if="curBoderGame === 'CrazyGraffiti'" @back="curBoderGame = ''" />
    <FishingCompetition v-if="curBoderGame === 'FishingCompetition'" @back="curBoderGame = ''" />
    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.pub-page {
  padding-top: 0;
  overflow: hidden;

  h4 {
    position: relative;

    .help-info {
      position: absolute;
      top: 0;
      right: 10px;
    }
  }

  .border-wrap {
    padding: 0 10px;
  }

  .border-game {
    .border-game-list {
      display: flex;
      flex-flow: column nowrap;

      button {
        margin-bottom: 10px;
        height: 60px;
        margin-left: 0;
        text-align: left;
        justify-content: flex-start;
        padding-left: 10%;

        i {
          font-size: 25px;
          margin-right: 10px;
        }

        p,
        h5 {
          margin: 0;
          text-align: left;
        }

        h5 {
          font-size: 16px;
          margin-bottom: 6px;
        }

        p {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
